import { useEffect, useState } from 'react';
import type { AdminConversation, ConversationFeedback } from '../../api/types.js';
import { displayName, formatRelative } from '../../lib/utils.js';

interface ConversationFeedbackPanelProps {
  conversation: AdminConversation;
  feedback: ConversationFeedback | null;
  onSave: (conversationId: number, summary: string) => Promise<void>;
}

export function ConversationFeedbackPanel({
  conversation,
  feedback,
  onSave,
}: ConversationFeedbackPanelProps) {
  const [summary, setSummary] = useState(feedback?.summary ?? '');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setSummary(feedback?.summary ?? '');
  }, [feedback?.summary]);

  const handleSave = async () => {
    const trimmed = summary.trim();
    if (!trimmed) return;
    setSaving(true);
    try {
      await onSave(conversation.id, trimmed);
    } finally {
      setSaving(false);
    }
  };

  const isSaved = Boolean(feedback?.updatedAt);

  return (
    <div className="profile-card">
      <section className="profile-section conversation-feedback-panel">
        <h3>{displayName(conversation)}</h3>
        <textarea
          maxLength={4000}
          placeholder="写下这轮会话的整体评价、AI 需要吸收的销售经验或应避免的问题。"
          value={summary}
          onChange={(e) => setSummary(e.target.value)}
        />
        <div className="conversation-feedback-actions">
          <button className="button primary" type="button" onClick={handleSave} disabled={saving || !summary.trim()}>
            {saving ? <span className="spinner" /> : '保存评语'}
          </button>
          <div className={`saved-status ${isSaved ? 'saved' : ''}`}>
            {isSaved ? <>✓ 已保存 · {formatRelative(feedback?.updatedAt)}</> : '未保存'}
          </div>
        </div>
      </section>
    </div>
  );
}
